import { UntypedFormGroup, UntypedFormControl, Validators, AsyncValidatorFn, AbstractControl } from '@angular/forms';
import { CustomValidator } from '../../../validators/custom.validator';
import { ItemNameValidator } from '../../../validators/item-name.validator';

export class ItemForm extends UntypedFormGroup {
  constructor(private itemNameValidator: ItemNameValidator) {
    super({
      id: new UntypedFormControl(null),
      name: new UntypedFormControl(null, [Validators.required], itemNameValidator.createValidator()),
      unit: new UntypedFormControl(null, [Validators.required]),
      recipeNumber: new UntypedFormControl(null),
      recipeCostId: new UntypedFormControl(null),
      itemTypeId: new UntypedFormControl(null, [Validators.required]),
      itemTypeName: new UntypedFormControl(null),
      nodeId: new UntypedFormControl(null, [Validators.required]),
      nodeName: new UntypedFormControl(null),
      unitPrice: new UntypedFormControl(null, [Validators.required, CustomValidator.isCommaSeparatedNumber]),
      isProduct: new UntypedFormControl(true),
      isService: new UntypedFormControl(false),
      recipeCost: new UntypedFormControl(null, [CustomValidator.isCommaSeparatedNumber]),
      isWet: new UntypedFormControl(true, [CustomValidator.isRequiredForConcrete]),
      radioButton: new UntypedFormControl('isProduct'),
      concreteTypeRadioButton: new UntypedFormControl('isWet'),
      clientId: new UntypedFormControl(null),
    });
  }

  forAdd() {
    return this;
  }
}
